export function removeStaticLoader() {
  const el = document.getElementById("staticloader");
  if (el && el.parentNode) {
    el.parentNode.removeChild(el);
  }
}
